import { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ProtectedRoute, PublicRoute } from "@/components/common/ProtectedRoute";
import { PageLoadingState } from "@/components/common/PageLayout";
import { ErrorBoundary } from "@/components/common/ErrorBoundary";

const EnhancedLoginPage = lazy(() => import("@/pages/auth/LoginPage"));
const EmailVerificationPage = lazy(() => import("@/pages/auth/EmailVerificationPage"));
const UserConfirmationPage = lazy(() => import("@/pages/auth/UserConfirmationPage"));
const StrategySelectionPage = lazy(() => import("@/pages/strategy/StrategySelectionPage"));
const SubscribePage = lazy(() => import("@/pages/strategy/SubscribePage"));
const BrokerSelectionPage = lazy(() => import("@/pages/broker/BrokerSelectionPage"));
const BrokerConnectPage = lazy(() => import("@/pages/broker/BrokerConnectPage"));
const PortfolioDashboard = lazy(() => import("@/pages/portfolio/PortfolioDashboard"));
const OrdersTradesPage = lazy(() => import("@/pages/portfolio/OrdersTradesPage"));
const WealthReportPage = lazy(() => import("@/pages/portfolio/WealthReportPage"));
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));

export function AppRoutes() {
  return (
    <ErrorBoundary>
    <Suspense fallback={<PageLoadingState />}>
      <Routes>
      <Route
        path="/login"
        element={
          <PublicRoute>
            <EnhancedLoginPage />
          </PublicRoute>
        }
      />
      <Route
        path="/verify-email"
        element={
          <PublicRoute>
            <EmailVerificationPage />
          </PublicRoute>
        }
      />
      <Route
        path="/confirm"
        element={
          <ProtectedRoute>
            <UserConfirmationPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/subscribe"
        element={
          <ProtectedRoute>
            <SubscribePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/strategies"
        element={
          <ProtectedRoute>
            <StrategySelectionPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/brokers"
        element={
          <ProtectedRoute>
            <BrokerSelectionPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/broker/connection"
        element={
          <ProtectedRoute>
            <BrokerSelectionPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/broker/fyers/connect"
        element={
          <ProtectedRoute>
            <BrokerConnectPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/broker/:id/connect"
        element={
          <ProtectedRoute>
            <BrokerConnectPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <PortfolioDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/orders-trades"
        element={
          <ProtectedRoute>
            <OrdersTradesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/report"
        element={
          <ProtectedRoute>
            <WealthReportPage />
          </ProtectedRoute>
        }
      />
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
    </Suspense>
    </ErrorBoundary>
  );
}
